import clsx from 'clsx';
import { RenderLoginMenu } from 'header/header/usermenu/RenderLoginMenu';
import { RenderLogoutMenu } from 'header/header/usermenu/RenderLogoutMenu';
import { RenderPostpage } from 'header/header/usermenu/RenderPostpage';
import { RenderUserInfo } from 'header/header/usermenu/RenderUserInfo';
import { RenderUserModifyPage } from 'header/header/usermenu/RenderUserModifyPage';
import { RenderUserMypage } from 'header/header/usermenu/RenderUserMypage';
import { useZstdHeader } from 'header/header/useZstdHeader';
import { useLoginInfo } from 'hooks/useLoginInfo';
import { tc } from 'language/i18nkey';
import { LANG_EN, LANG_KO_KR } from 'language/langutil';
import { Link } from 'react-router-dom';
import svcs from 'services';
import { fontFamilyMedium, fontFamilyRegular } from 'style/fonts';
import styled from 'styled-components';
import { loginutil } from 'util/loginutil';
import { useZstdInfo } from 'zstd/useZstdInfo';
import { CountrySelect } from './CountrySelect';

import { BRKS, STYLS } from 'util/variables';
import icon_admin_settings from './icon/engineering_setting.svg';

type Props = {
  main: boolean;
};
export const RenderUserPopup = (props: Props) => {
  const { isLoadingUserPopup, isPartner, countrySelect } = useZstdHeader();
  const { showUserPopup, setShowUserPopup } = useZstdInfo();
  const loginInfo = useLoginInfo();
  const { main } = props;

  const allowWritepage = (): boolean => {
    const lang = svcs.svcLang.lang();
    const info = loginInfo;

    // function
    if (loginutil.islogin(info)) {
      if (loginutil.iswels(info)) return true;
    } else {
      return false;
    }

    if (lang == LANG_KO_KR) return true;
    if (lang == LANG_EN) {
      if (isPartner) return true;
    }

    return false;
  };

  return (
    <UserPopupWrap className={clsx({ main: props.main })}>
      {!isLoadingUserPopup && showUserPopup && (
        <div className={'UserPopupContent'} style={{ overflow: 'hidden', height: '70rem' }}>
          <UserPopup onClick={(e) => e.stopPropagation()} $main={props.main} $logined={loginutil.islogin(loginInfo)}>
            <UserInfo>{loginutil.islogin(loginInfo) ? <RenderUserInfo /> : <RenderLoginMenu />}</UserInfo>
            {loginutil.islogin(loginInfo) && <RenderUserMypage />}
            {allowWritepage() && <RenderPostpage />}
            {loginutil.islogin(loginInfo) && <RenderUserModifyPage />}
            {loginutil.islse(loginInfo) && (
              <UserAdmin>
                <button
                  onClick={() => {
                    useZstdInfo.setState({ showUserPopup: false });
                  }}>
                  <Link to={'/borisPage'}>
                    <img alt={'popup_admin.svg'} src={icon_admin_settings} />
                    {/* {trans("I18N_TITLE_SETTINGS")} */}
                    {tc('i18n_head_menu_admin_settings')}
                  </Link>
                </button>
              </UserAdmin>
            )}
            {loginutil.islogin(loginInfo) && <RenderLogoutMenu />}
          </UserPopup>
        </div>
      )}

      {/*국가언어 버튼 클릭시 팝업*/}
      {countrySelect && (
        <CountrySelectWrap $main={main} className={'UserPopupContent'} style={{ overflow: 'hidden', height: '70rem' }}>
          <CountrySelect main={props.main} />
        </CountrySelectWrap>
      )}
    </UserPopupWrap>
  );
};

const CountrySelectWrap = styled.div<{ $main: boolean }>`
  right: ${(p) => (p.$main ? '9rem' : '3.2rem')};

  @media screen and (max-width: ${BRKS.tabletMax}) {
    right: 0rem;
  }
`;

const UserAdmin = styled.div`
  padding: 0 1rem;
  button {
    padding: 0rem 0.6rem;
  }
`;

const UserPopupWrap = styled.div`
  position: fixed;
  top: 7rem;
  z-index: 110;
  width: 100%;

  &.main {
    position: absolute;
    top: 10rem;

    @media screen and (max-width: ${BRKS.tabletMax}) {
      top: 5rem;
    }

    .UserPopupContent {
      max-width: initial;
      right: 0.2rem;
    }
  }

  @media screen and (max-width: ${BRKS.tabletMax}) {
    top: 7rem;
  }

  @media screen and (max-width: ${BRKS.mobileMax}) {
    top: 5rem;
  }

  .UserPopupContent {
    max-width: 120rem;
    margin: 0 auto;
    position: relative;
  }
`;

const UserPopup = styled.div<{ $main: boolean; $logined: boolean }>`
  background: white;
  font-size: 1.6rem;
  width: ${(p) => (p.$logined ? '26rem' : '18.2rem')};
  position: absolute;
  top: 0;

  z-index: 102;
  // box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  box-shadow: ${STYLS.boxShadow};
  border-radius: 8px;
  color: #2a2c2f;

  right: ${(p) => (p.$main ? '4rem' : '0')};
  @media screen and (max-width: ${BRKS.tabletMax}) {
    right: 0;
  }

  &.country-select {
    width: auto;
    min-width: 11rem;
    right: 3rem;

    button {
      height: 4.8rem;
      line-height: 4.8rem;
      display: block;
      padding: 0 1.6rem;
      border-bottom: 0.1rem solid #c8d6ea;

      span.bold {
        ${fontFamilyMedium};
        font-size: 1.2rem;
        color: #2a2c2f;
        padding-right: 0.6rem;
      }

      span.light {
        ${fontFamilyRegular};
        font-size: 1rem;
        color: #7783a1;
      }
    }

    button:last-child {
      border-bottom: none;
    }
  }

  > div {
    //border-bottom: solid 1px #C7D6EA;

    & button {
      border-radius: 0.4rem;
      &:hover {
        background-color: #e5e5e5;
      }
    }

    &:active {
      background: rgba(64, 126, 219, 0.3);
    }

    &:last-child {
      border-bottom: none;
    }

    > button {
      width: 100%;
      font-size: 1.6rem;
      text-align: left;
      color: #2a2c2f;
      ${fontFamilyMedium};

      a {
        display: block;
        width: 100%;
        color: #2a2c2f;
        padding: 1.6rem;
      }

      img {
        vertical-align: middle;
        margin-right: 0.8rem;
      }
    }
  }
`;

const UserInfo = styled.div`
  .login_btn {
    padding: 1.3rem;
  }

  .user_info_div {
    display: block;
    padding: 1.6rem;
    color: #2a2c2f;
    cursor: pointer;
  }

  .user_info {
    position: relative;
    margin-top: 0.4rem;

    > img {
      margin-right: 0.8rem;
      margin-bottom: 0.4rem;
    }

    > div {
      width: 100%;
      text-align: center;

      .name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        line-height: 2rem;
        margin-bottom: 0.6rem;
        color: #2a2c2f;

        span {
          display: inline-block;
          height: 2rem;
          line-height: 2rem;
          padding: 0 1.2rem;
          background: #7c899e;
          color: #fff;
          border-radius: 2rem;
          font-size: 1.2rem;
          margin-left: 0.4rem;
          ${fontFamilyMedium};
        }

        span.first {
          background: #edae0a;
        }

        span.second {
          background: #ff7a00;
        }

        span.third {
          background: #7b5df1;
        }

        span.fourth {
          background: #407edb;
        }

        span.fifth {
          background: #7c899e;
        }
      }

      .name_alt {
        display: none;
        font-size: 12px;
        color: #fff;
        background: rgba(42, 44, 47, 0.5);
        border-radius: 4px;
        max-width: 208px;
        padding: 0.8rem 1.2rem;
        text-align: left;
        ${fontFamilyRegular};
        font-style: normal;
        z-index: 9;
        position: absolute;
        left: 40%;
      }

      &:hover {
        .name_alt {
          display: inline-block;
        }
      }
    }

    .user_level {
      display: inline-block;
      width: 8rem;
      height: 2.4rem;
      line-height: 2.4rem;
      text-align: center;
      background: #fff;
      border: 1px solid #c7d6ea;
      border-radius: 100px;
      color: #7783a1;
      font-size: 1rem;
      position: absolute;
      right: 0;
      top: calc(50% - 1.2rem);
    }

    .my-alarm-txt {
      color: #7783a1;
      ${fontFamilyRegular};
      font-size: 1rem;

      span.alarm-counter {
        color: #e6003e;
        ${fontFamilyMedium};
      }
    }
  }
`;
